export default __webpack_public_path__ + "static/media/Logo_TIKTOK.a5fd23f8.svg";